export default "__VITE_ASSET__B1x$XjwC__"